// 歐克靈抗菌液稀釋計算機（次氯酸水）｜Shopify 主題 asset
// 由 theme.liquid 條件載入，僅在 /pages/hocl-dilution-calculator 執行
// v3（2026-09-01）：結果卡「您的濃度是/您的容器是」；瓶蓋≈8ml 以歐克靈10倍濃縮瓶蓋為標準
(function () {
  'use strict';
  if (!document.getElementById('sourceOpts')) return; // 頁面結構不存在則不執行

  var state = { source: '10x', sourcePpm: 1200, volume: 1000, target: 150 };

  function bindOpts(id, key, cb) {
    var box = document.getElementById(id);
    if (!box) return;
    box.querySelectorAll('.opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (key === 'source') {
          state.source = btn.dataset.source;
          var makerBox = document.getElementById('makerPpmOpts');
          makerBox.style.display = (state.source === 'maker') ? 'flex' : 'none';
          state.sourcePpm = state.source === '10x' ? 1200
            : Number(document.querySelector('#makerPpmOpts .opt.active').dataset.makerppm || 1200);
        }
        if (key === 'makerPpm') state.sourcePpm = Number(btn.dataset.makerppm);
        if (key === 'volume') state.volume = Number(btn.dataset.vol);
        if (key === 'target') state.target = Number(btn.dataset.target);
        cb();
        render();
      });
    });
  }

  bindOpts('sourceOpts', 'source', function () {});
  bindOpts('makerPpmOpts', 'makerPpm', function () {});
  bindOpts('volumeOpts', 'volume', function () {});
  bindOpts('targetOpts', 'target', function () {});

  var customVol = document.getElementById('customVol');
  var customTarget = document.getElementById('customTarget');
  if (customVol) customVol.addEventListener('input', function (e) {
    var v = Number(e.target.value);
    if (v > 0) {
      state.volume = v;
      document.querySelectorAll('#volumeOpts .opt').forEach(function (b) { b.classList.remove('active'); });
      render();
    }
  });
  if (customTarget) customTarget.addEventListener('input', function (e) {
    var v = Number(e.target.value);
    if (v > 0) {
      state.target = v;
      document.querySelectorAll('#targetOpts .opt').forEach(function (b) { b.classList.remove('active'); });
      render();
    }
  });

  // 計算：原液量 = 容器容量 × 目標ppm ÷ 原液ppm
  function render() {
    var stock = Math.round(state.volume * state.target / state.sourcePpm);
    var capTip = Math.max(1, Math.round(stock / 8)); // 1 瓶蓋≈8ml（歐克靈 10 倍濃縮瓶蓋）
    document.getElementById('resSourcePpm').textContent = state.sourcePpm;
    document.getElementById('resVolume').textContent = state.volume;
    document.getElementById('resStock').textContent = stock;
    document.getElementById('resPpm').textContent = state.target;
    document.getElementById('resTip').textContent = '約 ' + capTip + ' 瓶蓋（1 瓶蓋≈8ml，以歐克靈 10 倍濃縮瓶蓋為標準）';
    updateTable();
  }

  // 速查表：1L 容器，只列常用濃度，生活換算只用瓶蓋（湯匙無標準，已移除）
  function updateTable() {
    var ppm = state.sourcePpm;
    var rows = [
      { t: 100, note: '日常環境' },
      { t: 150, note: '噴瓶級' },
      { t: 200, note: '消毒級' },
      { t: 300, note: '加強消毒' }
    ];
    var tb = document.getElementById('tableBody');
    var html = '';
    rows.forEach(function (r) {
      var stock = Math.round(1000 * r.t / ppm);
      var life;
      if (stock === 500) life = '半瓶原液＋半瓶水';
      else if (stock === 1000) life = '整瓶原液';
      else life = Math.max(1, Math.round(stock / 8)) + ' 瓶蓋';
      html += '<tr><td class="ppm-tag">' + r.t + ' ppm</td><td>' + stock + ' ml</td><td>' + life + '</td></tr>';
    });
    tb.innerHTML = html;
    document.getElementById('tableTitle').textContent = '免計算速查表：' + ppm + 'ppm 原液稀釋（1L 容器）';
  }

  function copyResult() {
    var stock = Math.round(state.volume * state.target / state.sourcePpm);
    var capTip = Math.max(1, Math.round(stock / 8));
    var text = '歐克靈抗菌液調配：您的濃度 ' + state.sourcePpm + 'ppm、容器 ' + state.volume + 'ml，請加 ' + stock +
      'ml 原液到容器中並加滿，即是 ' + state.target + 'ppm（約 ' + capTip + ' 瓶蓋）';
    if (navigator.clipboard) navigator.clipboard.writeText(text);
    alert('✅ 配方已複製！可以貼到 Line 分享');
  }

  function shareResult() {
    var stock = Math.round(state.volume * state.target / state.sourcePpm);
    var text = encodeURIComponent('歐克靈抗菌液 ' + state.target + 'ppm 配方：' + state.volume +
      'ml 容器加 ' + stock + 'ml 原液＋水');
    if (navigator.share) navigator.share({ text: decodeURIComponent(text) });
    else { window.open('https://line.me/R/msg/text/?' + text, '_blank'); }
  }

  var copyBtn = document.getElementById('copyBtn');
  var shareBtn = document.getElementById('shareBtn');
  if (copyBtn) copyBtn.addEventListener('click', copyResult);
  if (shareBtn) shareBtn.addEventListener('click', shareResult);

  render();
})();
